<template>
    <div class="columns is-pointer has-text-centered" @click="goRoomInfo">
        <div class="column is-3">
            <p>{{ startHour }}</p>
            <p>{{ startDate }}</p>
        </div>
        <div class="column is-3 vertical-text">
            <p>{{ duration }} {{ $t("weekRooms.min") }}</p>
        </div>
        <div class="column is-6 vertical-text">
            <p>{{ description }}</p>
        </div>
    </div>
</template>

<script>
import moment from "moment";
export default {
    name: "closed-room",
    props: {
        room: {
            type: Object,
            required: true,
        },
    },
    computed: {
        startHour() {
            let date = moment(this.room.startDate);
            return date.format("HH:mm");
        },
        startDate() {
            let date = moment(this.room.startDate);
            return date.format("DD/MM/YYYY");
        },
        duration() {
            return this.room.duration;
        },
        description() {
            return this.room.description;
        },
    },
    methods: {
        goRoomInfo() {
            let url = this.$router.resolve({
                name: "room-info",
                params: { roomId: this.room.id },
            });
            window.open(url.href, "_blank");
        },
    },
};
</script>
